// src/utils.js
import moment from "moment";

// Static colors
export const colors = [
    "800000",
    "9A6324",
    "808000",
    "469990",
    "000075",
    "000000",
    "e6194B",
    "f58231",
    "ffe119",
    "bfef45",
    "3cb44b",
    "42d4f4",
    "4363d8",
    "911eb4",
    "f032e6",
    "a9a9a9",
];

// Cookie helpers
export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(name) === 0) return c.substring(name.length);
    }
    return "";
}

export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

// Format date helper
export function formatDate(date, format = "MMMM DD, YYYY") {
    return moment(date).format(format);
}
